import IAP_DEVICE_FEATURE_CODES from '../iap/iapDeviceFeatureCodes';
import {IAP_FEATURES_CODES} from '../iap/iapFeatureCodes';
import {uwmEntries} from './uwmEntries';

const UWM_FEATURE_ENTRIES = {
    [IAP_FEATURES_CODES.EXPERIENCE_SCORE]: {
        [IAP_DEVICE_FEATURE_CODES.ILUMA_I2]: uwmEntries.EXPERIENCE_COACH_MERCURY,
        [IAP_DEVICE_FEATURE_CODES.ILUMA_I5]: uwmEntries.INSIGHTS_ORION,
    },
    [IAP_FEATURES_CODES.ADVANCED_DIAGNOSTIC]: {
        [IAP_DEVICE_FEATURE_CODES.ILUMA_I2]: uwmEntries.DIAGNOSTIC_MERCURY,
    },
    [IAP_FEATURES_CODES.LOCATION]: {
        [IAP_DEVICE_FEATURE_CODES.ILUMA_I5]: uwmEntries.LOCATION,
    },
    [IAP_FEATURES_CODES.USAGE]: {
        [IAP_DEVICE_FEATURE_CODES.ILUMA_I2]: uwmEntries.USAGE_MERCURY,
    },
};

export default UWM_FEATURE_ENTRIES;
